<template>

  <div class="container-fluid">
    <form class="form-horizontal">
      <div class="form-group">
        <label class="control-label col-sm-2">{{$t('pages.createGroup.name')}}:</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="nameOfGroup" v-on:input = 'changeButton'>
        </div>
      </div>
      <div class="form-group">
        <label class="control-label col-sm-2" for="surname">{{$t('pages.createGroup.description')}}:</label>
        <div class="col-sm-10">
          <input @keyup.enter="createNewGroup" type="text" class="form-control" v-model="descriptionOfGroup">
        </div>
      </div>
      <div class="form-group">
        <label class="control-label col-sm-2" for="locale">{{ $t('pages.adminpanel.group.color') }}:</label>
        <div class="col-sm-10">
          <select class="form-control" v-model="colorOfGroup">
            <option v-for="barva in possibleColors">
              <div>{{barva}}</div>
            </option>
          </select>
        </div>
      </div>
      <!-- <div class="text-center">
        <div class="checkbox">
          <label>
            <input v-model="groupPublic" type="checkbox"> {{$t('pages.createGroup.public')}}
          </label>
        </div>
      </div> -->
      <div class="form-group">
        <div class="col-sm-offset-2 col-sm-10">
          <a v-if="" @click.prevent.stop="createNewGroup" class="btn btn-app pull-right">
            <i class="fa fa-plus"></i>{{create}}
          </a>
        </div>

      </div>
    </form>
  </div>

</template>

<script>
  import Rest from './../../services/rest'
  import { mapState } from 'vuex'
  export default {
    data () {
      return {
        nameOfGroup: '', // requied
        descriptionOfGroup: '',
        groupStatus: '',
        groupPublic: false,
        colorOfGroup: null,
        create: this.$t('pages.buttons.create')
      }
    },
    computed: {
      ...mapState(['possibleColors'])
    },
    methods: {
      createNewGroup: function () {
        if (this.nameOfGroup === '' && this.descriptionOfGroup === '') {
          // this.$store.state.adminpanel.colapseCreateGroup = !this.$store.state.adminpanel.colapseCreateGroup
          this.$store.commit('toggleCreateGroup')
          return
        }
        var postdata = {
          name: this.nameOfGroup,
          description: this.descriptionOfGroup,
          public: true,
          color: this.colorOfGroup
        }
        return Rest.request('POST', '/groups', postdata).then((data) => {
          this.create = this.$t('pages.buttons.success')
          this.groupStatus = this.$t('pages.createGroup.createGroupSMsg')
          this.$store.commit('toggleCreateGroup')
          this.$store.dispatch('getGroupsNew')
          this.$store.dispatch('getAllGroups')
          // var postdata2 = {
          //   groupId: data.id,
          //   name: (new Date().getFullYear()).toString(),
          //   visible: true
          // }
          // Rest.request('POST', '/years', postdata2).then((data2) => {
          //   this.create = this.$t('pages.buttons.success')
          //   this.groupStatus = this.$t('pages.createGroup.createGroupSMsg')
          //   this.$store.commit('toggleCreateGroup')
          //   // this.$store.commit('changeSaveResultAdminpanel', !this.$store.state.adminpanel.saveResult)
          //   this.$store.dispatch('getGroupsNew')
          //   this.$store.dispatch('getAllGroups')
          // }).catch((err) => {
          //   console.log(err)
          //   this.create = this.$t('pages.buttons.fail')
          //   this.groupStatus = err.responseJSON['message'] // TODO translate
          // })
        }).catch((err) => {
          console.log(err)
          this.create = this.$t('pages.buttons.fail')
          this.groupStatus = err.responseJSON['message'] // TODO translate
        })
      },
      changeButton: function () {
        this.create = this.$t('pages.buttons.create')
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// CreateGroup.vue?1dc29b31